<template>
  <v-container fluid>
    <Resource
      :create-form-component="() => import('../components/forms/Manufacturer.vue')"
      :meta="{name: 'fabrikant', namePlural: 'fabrikanten'}"
      :table-content="tableContent"
      :update-form-component="() => import('../components/forms/Manufacturer.vue')"
      resource-uri="manufacturer"
      can-search
    />
  </v-container>
</template>
<script>
import Resource from '@/components/Resource.vue';

export default {
  components: {Resource},
  name: 'ManufacturerResource',
  data() {
    return {
      tableContent: [
        {
          text: 'Naam',
          align: 'left',
          sortable: true,
          value: 'name',
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>
